module.exports = __webpack_public_path__ + "static/media/Room16.db97169d.PNG";